import { HIDE_ALERT, IS_LOADING, UPLOAD_COMPLETE, UPLOAD_RESET } from './types';

export const setIsLoading = isLoading => ({ type: IS_LOADING, payload: isLoading });

export const uploading = (status, message) => ({ type: UPLOAD_COMPLETE, payload: { message, status } });
export const resetUpload = () => ({ type: UPLOAD_RESET });
export const hideAlert = () => ({ type: HIDE_ALERT });
